
import React, {useEffect, useState} from 'react';
import Hashtag from "./Hashtag";
import './styles/chronic.css';




function App(props) {  
    const [chronic, setChronic] = useState();
    useEffect(() => {
                let url = "./configs/chronic.json";
                fetch(url)
                    .then(res => res.json())
                    .then(json => setChronic(json))
                }, []);

    return (
        chronic !=undefined?
        <div className="component-view animate" data-animate="blendin 3s">
        
        <div className="chronic-container" >
           
                    {
                        chronic.map(item=>(
                            <div className="chronic-content" >
                                                        
                                <div className="chronic-ts text-bold " >
                                    {item.ts}
                                </div>
                                        
                                <div className="chronic-description "> 
                                    {item.description}
                                </div>
                            
                            </div>
                        ))
                    }

</div> 
        </div>:null
    );
}
    
    export default App;